import React, { useState } from 'react';
import fileDownload from 'react-file-download';
import CargomaticDropzone from 'components/v2/DropZone';
import CargomaticModal from 'components/v2/modal';
import CargomaticInput from 'components/v2/input';
import { updateContainerAvailabilityBulk } from 'utils/AppointmentWebAPIUtils';
import { useTranslation } from 'react-i18next';
const dropzoneStyle = {
    display: 'flex',
    height: '50px',
    width: 'auto',
    border: '1px dashed black',
    borderRadius: '4px',
    cursor: 'pointer',
};
const csvTemplate = 'container_number,master_bill_number,available_by,yard_last_free_date,stack_position\n,,,,';
const BulkContainerAvailabilityModal = ({ showModal, onHide }) => {
    const [uploading, setUploading] = useState(false);
    const [suppressEmail, setSuppressEmail] = useState(false);
    const { t } = useTranslation();
    function resetModal() {
        setUploading(false);
        setSuppressEmail(false);
        onHide();
    }
    async function onUpload(file) {
        try {
            setUploading(true);
            await updateContainerAvailabilityBulk(file[0], suppressEmail);
            resetModal();
        }
        catch (e) {
            console.log(e);
            resetModal();
        }
    }
    return (React.createElement(CargomaticModal, { show: showModal, onHide: onHide, title: React.createElement("h3", { className: "text-lg font-medium text-gray-900 leading-6" },
            t('BULK_CONTAINER_AVAILABILITY_INFO'),
            React.createElement("span", { className: "pl-2 text-green px-1 cursor-pointer", onClick: () => fileDownload(csvTemplate, 'bulk-container-availability-update-template.csv') },
                React.createElement("i", { className: "fa fa-download" }))), backdrop: "static", body: React.createElement("div", null, uploading ? (React.createElement("div", { className: "flex" },
            React.createElement("fa", { className: "fa fa-spinner fa-spin text-green m-auto text-5xl" }))) : (React.createElement("div", null,
            React.createElement(CargomaticInput, { className: "pb-4", type: "checkbox", label: t('SUPPRESS_AVAILABILITY_EMAIL_NOTIFICATION'), checked: suppressEmail, onChange: setSuppressEmail }),
            React.createElement(CargomaticDropzone, { onDrop: onUpload, multiple: false, style: dropzoneStyle, dropzoneMessage: t('CLICK_DROP_FILE_TO_UPLOAD'), disabled: uploading })))), footer: null, location: "middle" }));
};
export default BulkContainerAvailabilityModal;
